import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';

import { Injectable } from '@angular/core';

import { Credentials, CredentialsService } from './credentials.service';
import { ValidateAccountCommand } from '@app/modules/authentication/commands/validate-account-command';

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  getRolSession() {
    throw new Error('Method not implemented.');
  }
  validateAccount(_verificationCommand: ValidateAccountCommand) {
    throw new Error('Method not implemented.');
  }
  getAllStoreCatalogs() {
    throw new Error('Method not implemented.');
  }

  constructor(private readonly credentialsService: CredentialsService) { }

    /**
     * Authenticates the user.
     *
     * @param context - The login parameters.
     * @returns The user credentials.
     */
    login(context: LoginContext): Observable<Credentials> {
        // Replace by proper authentication call
        const data = {
            username: context.username,
            token: '123456'
        };
        this.credentialsService.setCredentials(data, context.remember);

        return of(data);
    }

    /**
     * Logs out the user and clear credentials.
     *
     * @returns True if the user was logged out successfully.
     */
    logout(): Observable<boolean> {
        // Customize credentials invalidation here
        this.credentialsService.setCredentials();
        return of(true);
    }
}
